import {h, Fragment} from "preact"
import { useAppStateSelector } from "@nosto/preact"
import Sidebar from "./Sidebar"
import NativeToolbar from "./NativeToolbar"
import { SkeletonSidebar } from "./Skeleton"
/**
 * ContentWrapper takes a function to render non-empty results in the content area.
 * On loading the Loader is used and for empty results the NoResults component is used.
 */
function ContentWrapper({ type, children }) {
    const {
        foundProducts,
        loading
    } = useAppStateSelector(state => ({ 
        foundProducts: state.response.products?.total > 0, 
        loading: state.loading }))

    return (
        <>
        <NativeToolbar/>
        <div class="container"
            data-nosto-element={type}>
                <div class="collection">
            {foundProducts ? <Sidebar /> : <SkeletonSidebar />}
            <div
                class="gap-6 v-stack sm:gap-12"
                style={{ position: loading ? "relative" : "initial" }}>
                { children({ loading, foundProducts }) }
            </div>
            </div>
        </div>
        </>
    )
}

export function wrapContent(type, Component) {
    return () => (<ContentWrapper type={type}>{Component}</ContentWrapper>)
}

